/* global TradeInValuations */

import React, { Component } from "react"
import PropTypes from "prop-types"
import CarListElement from "./CarListElement"
import Pagination from "./Pagination"

export default class SuggestedCarsList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      page: 0,
      maxPage: 0,
    }
  }

  _renderSuggestedCars = () => {
    const start = this.state.page * 6
    const end = start + 6

    return this.props.cars
      .slice(start, end)
      .map((car) => (
        <CarListElement
          car={car}
          key={car.id}
          onClick={(carId) => this.props.onClick(carId)}
          selectedCar={this.props.selectedCar}
          strings={this.props.strings}
          submitAction={() => this.props.submitAction()}
          fromBookTestDrive={this.props.fromBookTestDrive}
        />
      ))
  }

  _handlePageChange = (e, page) => {
    e.preventDefault()
    // call action in trade_in_valuations.coffee:
    TradeInValuations.suggestedCarsPageChange()
    this.setState({ page })
  }

  render() {
    const { cars, strings } = this.props

    return (
      <div className="suggested-cars-list">
        {this._renderSuggestedCars()}
        {cars.length ? (
          <Pagination
            currentPage={this.state.page}
            onClick={(e, newPageNumber) =>
              this._handlePageChange(e, newPageNumber)
            }
            previousButtonText={strings.previousButtonText}
            nextButtonText={strings.nextButtonText}
            totalPages={Math.ceil(cars.length / 6)}
          />
        ) : null}
      </div>
    )
  }
}

SuggestedCarsList.propTypes = {
  cars: PropTypes.array,
  onClick: PropTypes.func,
  selectedCar: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  strings: PropTypes.object,
  submitAction: PropTypes.func,
  fromBookTestDrive: PropTypes.bool,
}
